var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { SliceContent } from './slice-content';
import { CellLabel } from '../elements/cell-label';
import { sliceFontTypes } from '../utils';
import { useSliceContent } from '../hooks/use-slice-content';
var cls = classNames('slice-description');
export var SliceDescriptionDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-bottom: ", ";\n    color: ", ";\n  "], ["\n    padding-bottom: ", ";\n    color: ", ";\n  "])), theme.UNIT(4), theme.COLOR('mid'))
});
var ContentStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var fontTypes = _a.fontTypes;
    return fontTypes.body && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      font-family: ", ";\n      p {\n        font-family: ", ";\n      }\n    "], ["\n      font-family: ", ";\n      p {\n        font-family: ", ";\n      }\n    "])), theme.FONT(fontTypes.body), theme.FONT(fontTypes.body));
  })
});
// -------- Components -------->
var My = {
  NAME: 'SliceDescription',
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled(CellLabel)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Content: styled(SliceContent)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
export var SliceDescription = function (props) {
  var componentProps = useComponentProps(My.NAME, props, SliceDescriptionDefaultProps);
  var className = componentProps.className,
    entity = componentProps.entity;
  var defn = useSliceContent(entity);
  if (!defn.shouldRender) {
    return null;
  }
  ;
  var fontTypes = sliceFontTypes(entity);
  var label = defn === null || defn === void 0 ? void 0 : defn.label;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, label && React.createElement(My.Label, null, label), React.createElement(My.Content, {
    fontTypes: fontTypes,
    entity: entity
  }));
};
SliceDescription.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;